import React, { useState, useEffect } from "react";
import {
  Grid,
  Button,
  List,
  ListItem,
  Box,
} from "@material-ui/core";
import PageHeader from "../../../Components/PageHeader";
import LeftControl from "../../../Components/LeftControl";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router";
import { environment } from "../../../environments/environment";

/** Local deoendencies & Libraries */
import Services from "../../../Services";
import DynamicTable from "../../../Components/TableComponents/DynamicTable";
import { Approval, FailPass, SecondApproval } from "../../../Components/TableComponents/constants";
import DynamicFormFields from "../../../Components/InputComponents/DynamicFormFields";
import { formatPhoneNumber, formatSSN } from "../../../Components/dummyConstant/DummyConstant";
import { getQuestion, getDataSheet, showTextEmpty } from "../../../helpers/textValidation";
import { Modal } from "antd";
import { DownloadForOffline, PrintOutlined } from "@mui/icons-material";
import { showSnackBar } from "../../../helpers/showSnackBar";
import Snackbar from "../../../Components/Snackbar";
import QuestionaireDataSheet from "./Questionaire&DataSheet";
import roleManager from "../../../Components/roles";
import GoBack from "../../../Components/GoBackButton/GoBack";
import { EditOutlined } from "@ant-design/icons";
import EditableModal from "./ModalsStep2";
import PageLayout from "../../../Components/LayoutComponents/PageLayout";

const { hr } = Services;
var moment = require("moment-timezone");

const { apiPath } = environment;

const NewHireStep2 = () => {
  let history = useHistory();
  const location = useLocation();

  const [applicantData, setApplicantData] = useState({});
  const [DataSheetDataEmergency, setDataSheetDataEmergency] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [userFiles, setUserFiles] = useState([])
  const [attachments, setAttachments] = useState([]);
  const [approval, setapproval] = useState(Approval[0]);
  const [statusDateTime, setStatusDateTime] = useState({
    date: moment(new Date()).local().format("MM-DD-YYYY"),
    time: moment(new Date()).local().format("hh:mm a"),
  });
  const [OpenQuesModal, setOpenQuesModal] = useState(false)
  const [QuestionnaireData, setQuestionnaireData] = useState(null)
  const [DataSheetData, setDataSheetData] = useState(null)
  const [isDataSheetModalOpen, setisDataSheetModalOpen] = useState(false)
  // moment(value).format('MM/DD/YYYY')
  const [compCodeOptions, setCompCodeOptions] = useState([])
  const [payCodeOptions, setPayCodeOptions] = useState([])
  const [reload, setReload] = useState(false)


  const getCompCode = async () => {
    let res = await hr.onUpdateCompCodeList()
    setCompCodeOptions(res?.data)
  }

  const [padding, setPadding] = useState({
    padding: '61px 230px 60px 230px',
    background: 'yellow',
  });


  useEffect(() => {
    const handleResize = () => {
      const isSmallScreen = window?.innerWidth > 1647 || window?.innerHeight > 1106;
      setPadding(isSmallScreen ? '61px 397px 60px 397px' : '60px 238px 60px 238px');
    };

    // Initial call to set padding based on the initial window size
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // Empty dependency array to run the effect only once on mount

  const getPayCode = async () => {
    let res = await hr.onUpdatePayCodeList()
    setPayCodeOptions(res?.data)
  }

  useEffect(() => {
    window.scrollTo(0, 0);

    getCompCode()
    getPayCode()

  }, []);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  async function onFormSubmit(event) {
    event.preventDefault();
    let data = {};
    if (approval.value) {
      data = {
        employee_id: applicantData.id,
        comment: formFields?.Comment1,
        hire_date: moment(formFields?.hireDates)?.format('YYYY-MM-DD'),
        drug_test_date: moment(formFields?.drugTestDate).format('YYYY-MM-DD'),
        background_complete_at: moment(formFields?.backgroundCompletedAt).format('YYYY-MM-DD'),
        CompCode: formFields?.compCode?.id,
        PayCode: formFields?.payCode?.id,
        drug_test: formFields?.drugTest?.title === "Pass" ? true : false,
        background_check: formFields?.backgroundCheck?.title == "Pass" ? true : false,
        // attatchment: attachments?.length > 0 ? attachments : []
      };

    } else if (!approval.value) {
      data = {
        employee_id: applicantData.id,
        step: 3,
        comment: formFields?.Comment1,
        data: {
          drug_test_date: formFields?.drugTestDate,
          background_complete_at: formFields?.backgroundCompletedAt,
          drug_test: formFields?.drugTest?.title === "Pass" ? true : false,
          background_check: formFields?.backgroundCheck?.title == "Pass" ? true : false,
        },
      };
    }


    try {
      if (approval.value) {
        let res = await hr.step2(data)
        if (attachments?.length > 0 && res?.httpStatus == 200) {
          const formData = new FormData()
          attachments.forEach((attachment) => {
            formData.append('file', attachment)
          })
          await hr.additionalFiles({
            id: applicantData.id,
            formData
          })
        }
      }
      else if (!approval.value) {
        await hr.reject(data);
      }
      history.push("/new-hire-queue");
    } catch (exc) {

    }
  }

  const setStatus = async (status) => {
    setapproval(status);
    setStatusDateTime({
      date: moment(new Date()).local().format("MM-DD-YYYY"),
      time: moment(new Date()).local().format("hh:mm a"),
    });
  };

  const handleFormSubmit = async (values) => {
    let id = location?.state?.id;

    try {
      await hr.updateApplicant({ id, ...values });


      handleOk();
      setReload(!reload)
    } catch (error) {
      console.error('Error updating data:', error);
    }


  };

  useEffect(async () => {
    window.scrollTo(0, 0);

    let applicantDataHistory = location?.state;

    try {
      let data = await hr.getAllApplicantsByID(applicantDataHistory);
      setApplicantData({
        ...data.employee,
        createdAt: moment(data.employee).format('MM-DD-YYYY'),
      });
      setFormFields({ ...formFields })
      setUserFiles(data.files)
      setQuestionnaireData(data?.data?.questionaire)
      setDataSheetData(data?.employee)
      setDataSheetDataEmergency(data?.emergency_contact)

    } catch (exc) {

    }

  }, [reload]);


  const handleAttachements = async (e) => {
    let files = Array.from(e.target.files)
    let validTypes = ["application/pdf", "image/jpeg", "image/png", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]

    if (files?.length > 0) {
      files?.forEach(file => {
        if (!validTypes?.includes(file?.type)) {
          showSnackBar('File type not accepted!')
          return
        }
        setAttachments(prev => { return [...prev, file] })
      })
    }
  };



  //remove attachment
  const removeAttachment = (index) => {
    let files = attachments;
    files.splice(index, 1);
    setAttachments(Array.from(files));
  };

  let secondApData = {
    header: SecondApproval,
    rows: [applicantData]?.map((row) => [
      row?.id + " / " + row?.firstName + " " + row?.lastName,
      // row?.id,
      row?.createdAt,
      row?.SubDepartment?.Department?.name + " / " + row?.SubDepartment?.name,

      row?.city + ", " + row?.state,
      row?.ssn ? formatSSN(row?.ssn) : "N/A",
      formatPhoneNumber(row?.homePhone),
      row?.email,
      <Button onClick={showModal}> <EditOutlined /></Button>,
    ])
  }


  const [formFields, setFormFields] = useState({});

  const handleOnSubmit = (value, key) => {
    setFormFields({ ...formFields, [key]: value })
  }
  let statusFields = [
    { type: 3, name: "2nd Approval", isRequired: true, keyName: 'Status', key: 'title', diffonChange2: setStatus, options: Approval },
    { type: 1, name: "Date", isDisabled: true, keyName: 'Date', initial: statusDateTime?.date },
    { type: 1, name: "Time", isDisabled: true, keyName: 'Date', initial: statusDateTime?.time },
  ]


  let midFields = [
    { type: 2, name: "Drug Test Date", keyName: 'drugTestDate', initial: formFields?.drugTestDate || new Date() },
    { type: 3, name: "Drug Test", isRequired: true, keyName: 'drugTest', key: 'title', options: FailPass },
    { type: 2, name: "Background Completed At", keyName: 'backgroundCompletedAt', initial: formFields?.backgroundCompletedAt || new Date() },
    { type: 3, name: "Background Check", keyName: 'backgroundCheck', key: 'title', options: FailPass },
    { type: 3, name: "Comp Code", keyName: 'compCode', key: 'name', options: compCodeOptions },
    { type: 3, name: "Pay Code", keyName: 'payCode', key: 'name', options: payCodeOptions },
    { type: 2, name: "Hire Date", keyName: 'hireDates', initial: formFields?.hireDates || new Date(), },
    {
      type: 6, name: "Comments", maxLength:'250',keyName: 'Comment1', minRows: 6, placeHolder: "Comment here", isRequired: approval?.value ? false : true,
      typography: approval?.value
        ? `Please leave this field empty if you have no comments`
        : `Please define the reason of rejection`,

    },
  ]

  const handleCloseQuesModal = () => {
    setOpenQuesModal(false)
  }

  const onCancelDataSheetModal = () => {
    setisDataSheetModalOpen(false)
  }

  let QDProps = {
    handleCloseQuesModal,
    onCancelDataSheetModal,
    QuestionnaireData,
    DataSheetData,
    DataSheetDataEmergency,
    OpenQuesModal,
    setOpenQuesModal,
    isDataSheetModalOpen,
    setisDataSheetModalOpen
  }

  return (
    <PageLayout className="Liq-Container HRPortal" id="newHireQueuePage">
      <QuestionaireDataSheet {...QDProps} />
      <Grid className="PagesFrame">
        <PageHeader />
        <Grid id="PageTitle">Applicant - 2nd Approval</Grid>
        <GoBack path={"/new-hire-queue"} mt="10px" />
        <Grid xs={12} className="ContentPage BlueHeadTable FormTableArea">
          <Grid xs={12} className="LiqTables">
            <DynamicTable tableData={secondApData} Pagination={false} />
            <Grid xs={2} style={{ marginTop: "20px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                {roleManager("employeeLookup", "sections", "questionare") &&
                  <Button
                    className="QD-Btn-link"
                    onClick={() => setOpenQuesModal(true)}
                  >
                    Questionnaire
                  </Button>
                }

                <Button
                  className="QD-Btn-link"
                  onClick={() => setisDataSheetModalOpen(true)}
                >
                  Data Sheet
                </Button>
              </div>
            </Grid>
          </Grid>
          <Grid xs={12} md={8} lg={8}>
            <form onSubmit={onFormSubmit}>
              <Grid xs={12} container className="LRM40">

                <Box sx={{ display: "grid", gap: "10px 35px", gridTemplateColumns: "repeat(3,1fr)", width: "100%" }}>
                  <DynamicFormFields grid={true} fields={statusFields} onChange={handleOnSubmit} />
                </Box>


              </Grid>

              <Grid xs={12}>

                <Grid xs={12} container>
                  <Box sx={{ display: "grid", gap: "10px 35px", gridTemplateColumns: "repeat(2,1fr)", width: "100%" }}>
                    <DynamicFormFields grid={true} onChange={handleOnSubmit} fields={midFields.slice(0, 6)} />
                  </Box>

                </Grid>

                {approval.value && (
                  <Grid xs={12} container>
                    <Box sx={{ display: "grid", gap: "10px 35px", gridTemplateColumns: "repeat(1,1fr)", width: "100%" }}>
                      <DynamicFormFields grid={true} onChange={handleOnSubmit} fields={midFields.slice(6, 7)} />
                    </Box>
                  </Grid>
                )}

                <Grid xs={12} container>
                  <Box sx={{ display: "grid", gap: "10px 35px", gridTemplateColumns: "repeat(1,1fr)", width: "100%" }}>
                    <DynamicFormFields grid={true} onChange={handleOnSubmit} fields={midFields.slice(7, 8)} />
                  </Box>
                </Grid>

                {approval.value && (
                  <Grid xs={12} container>
                    <Grid xs={12} className="mt30">
                      <Grid xs={12}>
                        <Grid xs={12} className="mbold">
                          Attach Additional Files
                        </Grid>

                        <Grid
                          xs={12}
                          id="Step2DragFile"
                          className="Step2DragFile mt14"
                        >
                          {/*  */}
                          <label>
                            <input
                              type="file"
                              accept="application/pdf"
                              multiple
                              onChange={handleAttachements}
                              list="none"
                              style={{ display: 'none' }}
                            />
                            {/* <a style={{ padding: '61px 393px 60px 230px', background: 'none' }}> */}

                            <a style={{ padding: padding, background: 'none' }}>
                              Select Files
                            </a>

                          </label>
                        </Grid>
                        {attachments.map((attachment, index) => {
                          return (
                            <Grid xs={12} className="attachmentsHR">
                              <div>{`${attachment.name}`}
                                <Button
                                  onClick={() => removeAttachment(index)}
                                >
                                  x
                                </Button>
                              </div>
                            </Grid>
                          );
                        })}
                      </Grid>
                    </Grid>
                  </Grid>
                )}
                <Grid
                  xs={12}
                  container
                  justify="space-between"
                  className="mt50"
                >
                  <Button className="LinkButton" type="submit">
                    Submit Application
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>

          <Grid style={{ padding: '15px', marginTop: '15px' }} xs={12} md={8} lg={4}>
            <h5 style={{ margin: '0' }}>Forms</h5>
            <List>
              {userFiles.map((name) => (
                <ListItem container className="p0 pt6 pb20">
                  <Grid lg={12} className="PDFDownload button">
                    <a
                      className="doc-download-flex"
                      href={`${apiPath}/employee/applicant/download?id=${applicantData?.id}&name=${name}`}
                      target="_blank"
                    >
                      <Grid className="FileName">{name}</Grid>
                      <DownloadForOffline style={{ marginTop: "0px", color: "gray" }} />
                    </a>
                  </Grid>
                </ListItem>
              ))}

            </List>
            <div>
              {/* <Modal title="Basic Modal" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                  <p>Some contents...</p>
                  <p>Some contents...</p>
                  <p>Some contents...</p>
                </Modal> */}
              <EditableModal isModalOpen={isModalOpen} handleOk={handleOk} handleCancel={handleCancel} applicantData={applicantData} handleFormSubmit={handleFormSubmit}  // Pass the necessary data as a prop
              />
            </div>
          </Grid>

        </Grid>
        {/* Page Start End */}
      </Grid>
      <Snackbar></Snackbar>
    </PageLayout>
  );
};

export default NewHireStep2;
